module.exports = __webpack_public_path__ + "img/rtu.52c2a38d.png";